// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};

export const firebaseConfig = {
  apiKey: "AIzaSyA65NOUxVKcIZXmoLlLhLgZfH-RFR5TPPM",
  authDomain: "iconawebsite-e7cdd.firebaseapp.com",
  databaseURL: "https://iconawebsite-e7cdd-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "iconawebsite-e7cdd",
  storageBucket: "iconawebsite-e7cdd.appspot.com",
  messagingSenderId: "646814169573",
  appId: "1:646814169573:web:fa0abbb4ef977eac6e170c",
  measurementId: "G-JX6SNFXWJX"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
